/**
 * Collection of font families used throughout the application.
 */
export const fonts = {
  franklin: `figtree, helvetica, arial, sans-serif`,
};
